import { Component, Input, OnInit } from '@angular/core';
import { LngLatLike } from 'mapbox-gl';
import { MapService } from '../map/map.service';

@Component({
  selector: 'app-fly-to',
  templateUrl: './fly-to.component.html',
  styleUrls: ['./fly-to.component.scss']
})
export class FlyToComponent implements OnInit {

  @Input()
  lngLat: LngLatLike;

  constructor(
    private mapService: MapService
  ) { }

  ngOnInit(): void {
  }

  flyTo(): void {
    this.mapService.map$
      .subscribe(m => m.flyTo({
        center: this.lngLat,
        zoom: 20
      }));
  }

}
